export default {
  Codigo: null,
  Cantidad: 0,
  Fecha: null,
};
